export default __webpack_public_path__ + "static/media/katana2.515955aa.jpg";